import PptxGenJS from "pptxgenjs";
import { calculateGlobalNorm } from "./slide2";

export const slide3 = (pptx: PptxGenJS, data: any) => {
    const slide = pptx.addSlide();
    const reportData = data?.data
    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });
    slide.addText("Your 360 Feedback Snapshot (contd.)", {
        x: 0.5,
        y: 0.8,
        w: 7.27,
        h: 0.5,
        fontSize: 18,
        bold: true,
        color: '000000'
    });

    // Subtitle
    slide.addText("Growth Areas (Bottom 3 behaviours with the lowest scores)", {
        x: 0.5,
        y: 1.4,
        w: 7.27,
        h: 0.3,
        fontSize: 14,
        bold: true,
        color: '000000'
    });
    const addProgressBar = (s: any, x: number, y: number, w: number, score: number, globalNorm: number) => {
        const barHeight = 0.15;
        const scale = 5;
        const orangeWidth = (Math.min(score, scale) / scale) * w;
        const normPos = (Math.min(globalNorm, scale) / scale) * w;

        // Background bar
        s.addShape('rect', {
            x: x, y: y, w: w, h: barHeight,
            fill: { color: 'F0F0F0' },
            line: { type: 'none' }
        });

        // Orange progress
        s.addShape('rect', {
            x: x, y: y, w: orangeWidth, h: barHeight,
            fill: { color: 'FF6600' },
            line: { type: 'none' }
        });

        // Global Norm tick
        s.addShape('rect', {
            x: x + normPos, y: y - 0.05, w: 0.03, h: barHeight + 0.1,
            fill: { color: '404040' },
            line: { type: 'none' }
        });
    };

    // Growth Areas Table
    const tableTop = 1.8;
    slide.addShape('rect', { x: 0.5, y: tableTop, w: 7.27, h: 2.0, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5, y: tableTop, w: 7.27, h: 0.6, fill: { color: 'EAEAEA' }, line: { color: '404040', width: 1 } });

    // Headers
    const headers = ["Growth Area", "YOUR SCORE", "GLOBAL NORM"];
    const headerX = [0.6, 3.2, 4.0];
    headers.forEach((h, i) => {
        slide.addText(h, { x: headerX[i], y: tableTop + 0.15, w: 1.5, h: 0.3, fontSize: 10, bold: true });
    });

    const rawStrengths = reportData?.participantReport?.combinedQuestions?.length ?
        reportData?.participantReport?.combinedQuestions
        : []
    const growthAreas: { text: string; score: number; norm: number }[] =
        rawStrengths
            ?.sort((a: any, b: any) => {
                const aScore = a?.my_score ?? null;
                const bScore = b?.my_score ?? null;
                if (aScore === null && bScore === null) return 0;
                if (aScore === null) return 1;
                if (bScore === null) return -1;
                return aScore - bScore;
            })
            ?.slice(0, 3)
            ?.map((q: any) => {
                return {
                    text: q?.text,
                    score: q?.my_score,
                    norm: calculateGlobalNorm(q?.raters),
                };
            });

    growthAreas.forEach((item: any, i: number) => {
        const rowY = tableTop + 0.6 + (i * 0.7);
        slide.addShape('rect', { x: 0.5, y: rowY, w: 7.27, h: 0.7, line: { color: '404040', width: 0.5 } });

        slide.addText(item.text, { x: 0.6, y: rowY, w: 2.5, h: 0.7, fontSize: 9, color: '404040', valign: 'middle' });
        slide.addText(item.score.toFixed(2), { x: 3.2, y: rowY, w: 0.7, h: 0.7, fontSize: 11, bold: true, color: 'FF6600', align: 'center', valign: 'middle' });
        slide.addText(item.norm.toFixed(2), { x: 4.0, y: rowY, w: 0.7, h: 0.7, fontSize: 11, bold: true, align: 'center', valign: 'middle' });

        addProgressBar(slide, 4.8, rowY + 0.28, 2.8, item.score, item.norm);
    });

    // Footer
    const candidateName = data?.candidateName || 'Jane Doe';
    slide.addText(`360-Degree Feedback Individual Report for ${candidateName}`, {
        x: 0,
        y: 11.2,
        w: 7.8,
        h: 0.3,
        fontSize: 9,
        color: '666666',
        align: 'center'
    });

    // slide.addText("4", {
    //     x: 7.8,
    //     y: 11.2,
    //     w: 0.4,
    //     h: 0.3,
    //     fontSize: 9,
    //     color: '666666',
    //     align: 'center'
    // });
};
